import { useField } from 'formik';

import { controlError } from 'utils';

import { Input, InputProps } from '../input';

export interface InputFieldProps extends Omit<InputProps, 'name'> {
  name: string;
  label?: string;
  displayValue?: unknown;
  onChange?: InputProps['onChange'];
  mapValue?: (value: unknown) => unknown;
}

export function InputField({
  name,
  label,
  onBlur,
  onChange,
  mapValue,
  displayValue,
  ...props
}: InputFieldProps) {
  const [field, meta, helpers] = useField<unknown>(name);

  const errorText = controlError(meta, name, label);

  return (
    <Input
      {...props}
      {...field}
      label={label}
      error={!!errorText}
      helperText={errorText}
      value={displayValue ?? field.value ?? ''}
      onBlur={(event) => {
        field.onBlur(event);
        onBlur?.(event);
      }}
      onChange={(event) => {
        if (mapValue) {
          helpers.setValue(mapValue(event.target.value), true);
        } else {
          field.onChange(event);
        }
        onChange?.(event);
      }}
    />
  );
}
